import { render } from "./addAttachment.vue?vue&type=template&id=6654d384&scoped=true"
import script from "./addAttachment.vue?vue&type=script&lang=js"
export * from "./addAttachment.vue?vue&type=script&lang=js"

import "./addAttachment.vue?vue&type=style&index=0&id=6654d384&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6654d384"]])

export default __exports__